import React from 'react';
import { siteConfig } from '../data/siteConfig';
export function Header() {
  return <header className="sticky top-0 z-40 bg-ivory/95 backdrop-blur border-b border-ink/10" data-id="element-80" data-mp="2dm4h6dqijsz0">
      <a href="#contenu" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-3 focus:z-50 focus:bg-ivory focus:px-4 focus:py-2 focus:text-sm focus:font-semibold" data-id="element-81" data-mp="2ilh4ezlar224">
        Aller au contenu
      </a>
      
    </header>;
}